import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportListComponent} from './components/report-list/report-list.component'

import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportsContainerComponent } from './container/reports-container/reports-container.component';

const routes: Routes = [
  { path: '', component: ReportsContainerComponent  },
  { path: 'report-list', component: ReportListComponent  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
